import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { validate } from 'src/api/validate';
import { IValidateRequestBody, IValidateResponseBody } from 'src/api/validate/types';

type Options = Omit<UseMutationOptions<IValidateResponseBody, unknown, IValidateRequestBody, unknown>, 'mutationFn'>;

export const useValidate = (options: Options = {}) => {
  return useMutation((payload: IValidateRequestBody) => validate(payload), options);
};
